export const BLACK = '#0C0C0C';
export const LIGHT_GREY = '#F5F5F5';
export const DARK_GREY = '#868BA0';
export const RED = '#FE0201';
export const WHITE = '#FFFFFF';
export const XOS_RED = '#c94141';
export const XOS_GREEN = '#28a745';
